module.exports = __webpack_public_path__ + "static/img/Ajustados sin fondo_revisar.ce30bb52.svg";